import { Component } from '@angular/core';

interface GcfcLink { label: string; href: string; }

@Component({
  selector: 'app-tenant-footer-gcfc',
  standalone: false,
  templateUrl: './tenant-footer-gcfc.component.html',
  styleUrls: ['./tenant-footer-gcfc.component.scss'],
})
export class TenantFooterGcfcComponent {
  readonly currentYear = new Date().getFullYear();

  readonly filmHere: GcfcLink[] = [
    { label: 'Why Film in Cleveland?',  href: 'https://www.clevelandfilm.com/film-here/why-film-in-cleveland' },
    { label: 'Incentives & Permits',    href: 'https://www.clevelandfilm.com/film-here/incentives-permits' },
    { label: 'Locations',               href: 'https://www.clevelandfilm.com/film-here/locations' },
    { label: 'Crew Directory',          href: 'https://www.clevelandfilm.com/film-here/crew-directory' },
    { label: 'Vendor Directory',        href: 'https://www.clevelandfilm.com/film-here/vendor-directory' },
    { label: 'Casting Agencies',        href: 'https://www.clevelandfilm.com/film-here/casting-agencies' },
    { label: 'Union Contracts',         href: 'https://www.clevelandfilm.com/film-here/union-contracts' },
    { label: 'Production Support',      href: 'https://www.clevelandfilm.com/film-here/production-support' },
    { label: 'Financial Resources',     href: 'https://www.clevelandfilm.com/film-here/financial-resources' },
    { label: 'Locations Map',           href: 'https://www.clevelandfilm.com/film-here/locations-map' },
  ];

  readonly workHere: GcfcLink[] = [
    { label: 'Careers in Film',                  href: 'https://www.clevelandfilm.com/work-here/careers-in-film' },
    { label: 'Getting Started',                  href: 'https://www.clevelandfilm.com/work-here/getting-started' },
    { label: 'Industry Job Opportunities',       href: 'https://www.clevelandfilm.com/work-here/industry-opportunities' },
    { label: 'Training',                         href: 'https://www.clevelandfilm.com/work-here/training' },
    { label: 'Internships',                      href: 'https://www.clevelandfilm.com/work-here/internships' },
    { label: 'Inclusive Industry Resources',     href: 'https://www.clevelandfilm.com/work-here/inclusive-industry-resources' },
    { label: 'Vendor Support',                   href: 'https://www.clevelandfilm.com/work-here/vendor-support' },
  ];

  readonly joinGive: GcfcLink[] = [
    { label: 'Support Our Mission',                 href: 'https://www.clevelandfilm.com/join-give/support-our-mission' },
    { label: 'Donate',                              href: 'https://www.clevelandfilm.com/join-give/donate' },
    { label: 'Memberships',                         href: 'https://www.clevelandfilm.com/join-give/memberships' },
    { label: 'Investor Opportunities',              href: 'https://www.clevelandfilm.com/join-give/investor-opportunities' },
    { label: 'Volunteer Opportunities',             href: 'https://www.clevelandfilm.com/join-give/volunteer-opportunities' },
    { label: 'How to Support Local Film Projects',  href: 'https://www.clevelandfilm.com/join-give/how-to-support-local-film-projects' },
    { label: 'GCFC Merchandise',                    href: 'https://www.clevelandfilm.com/join-give/gcfc-merchandise' },
    { label: 'Partners',                            href: 'https://www.clevelandfilm.com/join-give/partners' },
  ];

  readonly about: GcfcLink[] = [
    { label: 'Mission & Vision',         href: 'https://www.clevelandfilm.com/about/mission-vision' },
    { label: 'Our Impact',               href: 'https://www.clevelandfilm.com/about/our-impact' },
    { label: 'Commitment to Equity',     href: 'https://www.clevelandfilm.com/about/commitment-to-equity' },
    { label: 'Staff & Board Members',    href: 'https://www.clevelandfilm.com/about/staff-board-members' },
    { label: 'Careers',                  href: 'https://www.clevelandfilm.com/about/careers' },
  ];

  readonly ourImpact: GcfcLink[] = [
    { label: 'Overview',           href: 'https://www.clevelandfilm.com/about/our-impact/overview' },
    { label: 'Economic Impact',    href: 'https://www.clevelandfilm.com/about/our-impact/economic-impact' },
    { label: 'Success Stories',    href: 'https://www.clevelandfilm.com/about/our-impact/success-stories' },
    { label: 'Community Impact',   href: 'https://www.clevelandfilm.com/about/our-impact/community-impact' },
  ];

  readonly contact: GcfcLink[] = [
    { label: 'Events',                 href: 'https://www.clevelandfilm.com/events' },
    { label: 'The Latest',             href: 'https://www.clevelandfilm.com/the-latest' },
    { label: 'Crew/Vendor Login',      href: 'https://cleveland.reel-scout.com/crew_login.aspx' },
    { label: 'Crew/Vendor Register',   href: 'https://cleveland.reel-scout.com/crew_registration.aspx' },
  ];

  readonly socials = [
    { label: 'Instagram', href: 'https://www.instagram.com/clevelandfilm/' },
    { label: 'LinkedIn',  href: 'https://linkedin.com/company/greater-cleveland-film-commission' },
    { label: 'Facebook',  href: 'https://www.facebook.com/ClevelandFilm/' },
    { label: 'YouTube',   href: 'https://www.youtube.com/channel/UCwp5bxeklwmqgqS19hUKfyA' },
    { label: 'X',         href: 'https://x.com/Cleveland_Film/' },
  ];

  readonly newsletterHref = 'https://www.clevelandfilm.com/the-latest';
  readonly donateHref = 'https://www.clevelandfilm.com/donate';
  readonly membershipsHref = 'https://www.clevelandfilm.com/join-give/memberships';
}
